<template>
  <div v-if="this.$store.state.htmlError">
    <div class="errorBlock text-center p-3">
      <b-row>
        <b-col>
          {{ $t("error.request") }}
        </b-col>
      </b-row>
      <b-row v-if="this.$store.state.htmlError.response.data.message == null && $t('error.payment.' + this.$store.state.htmlError.response.data.errorCode) == null">
        <b-col>
          {{ this.$store.state.htmlError }}
        </b-col>
      </b-row>
    </div>
    <div v-if="this.$store.state.htmlError.response.data.errorCode">
      <b-row>
        <b-col>
          {{ $t("error.payment." + this.$store.state.htmlError.response.data.errorCode) }}
        </b-col>
      </b-row>
    </div>
    <div v-if="this.$store.state.htmlError.response.data.message && this.$store.state.htmlError.response.data.message.length > 0">
      <b-link @click="toggle = !toggle">{{ $t("error.details") }}</b-link>
      <div v-show="toggle">
        <b-row>
          <b-col>
            {{ this.$store.state.htmlError.response.data.message }} <br />
          </b-col>
        </b-row>
        <b-row class="text-center">
          <ul>
            <li v-for="detail in this.$store.state.htmlError.response.data.details" :key="detail">
              {{ detail }}
            </li>
          </ul>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toggle: false,
    };
  },
  mounted() {
    if (this.$store.state.htmlError != null && this.$store.state.htmlError.response != null)
      console.log(this.$store.state.htmlError.response.data);
  },
};
</script>
